export default "/assets/images/CC-product-showcase-01.088e5ed03995f351.jpg";